var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _circle2, _path11, _circle3, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup1261153973(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#30D8A7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.783 12.1172C18.3624 12.1172 18.0234 12.4895 18.0234 12.9529V27.0496C18.0234 27.5121 18.3624 27.8853 18.783 27.8853H29.6266C30.0472 27.8853 30.3862 27.5121 30.3862 27.0496V12.9529C30.3862 12.4895 30.0472 12.1172 29.6266 12.1172H18.783ZM18.6308 12.8096H29.7724V27.1849H18.6308V12.8096Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2329 14.2031H24.9219V15.9909H28.2329V14.2031Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2173 14.2031H20.9062V15.9909H24.2173V14.2031Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2329 16.6328H24.9219V18.4206H28.2329V16.6328Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2173 16.6328H20.9062V18.4206H24.2173V16.6328Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2329 19.125H24.9219V20.9128H28.2329V19.125Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2173 19.125H20.9062V20.9128H24.2173V19.125Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2329 21.6172H24.9219V23.405H28.2329V21.6172Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2173 21.6172H20.9062V23.405H24.2173V21.6172Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2329 24.0781H24.9219V25.8659H28.2329V24.0781Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2173 24.0781H20.9062V25.8659H24.2173V24.0781Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4297 29.8047L9.61719 27.8438V12.1631L21.4297 10.2031V29.8047ZM16.1982 16.6279L15.2285 18.8701C15.1686 19.0327 15.1471 19.1152 15.1533 19.2207C15.1397 19.13 15.1126 18.9955 15.0537 18.8701L14.2354 16.7441L12.8545 16.8262L14.2871 20.0674L12.6953 23.2988L14.0723 23.3809L15.0537 21.1045C15.0945 20.9936 15.0974 20.9432 15.1045 20.8818C15.1198 20.968 15.1046 20.9922 15.1807 21.168L16.1562 23.5049L17.7617 23.6006L15.9482 20.0195C16.5047 18.8479 17.0845 17.6874 17.6875 16.5391L16.1982 16.6279Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#30D8A7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2888 22.8298L17.9361 27.9949C18.1002 28.1658 18.4406 28.119 18.6515 27.9784L20.6337 26.4249L20.6365 25.9645C19.9031 24.95 19.6564 24.6095 17.422 21.4487L14.2888 22.8298ZM12.7064 22.7196C11.8049 22.1489 11.0715 21.3742 10.5532 20.4755V20.4741C10.0294 19.5671 9.72479 18.536 9.68484 17.4622C9.26718 17.7145 8.84538 17.9598 8.41667 18.1955C8.19337 20.4051 9.42294 22.5363 11.4478 23.446C11.8627 23.1951 12.2832 22.9525 12.7064 22.7196ZM25.0818 15.848C25.0859 15.8562 25.09 15.8631 25.0942 15.8714L26.6118 18.4973C22.0452 18.897 17.6547 20.1638 13.5691 22.2632C11.5994 21.2404 10.407 19.1631 10.5159 16.9439C14.3492 14.4711 17.6645 11.2827 20.285 7.53906L21.8219 10.2008L25.0818 15.848ZM26.587 13.557C27.2018 11.2633 24.9232 9.26322 22.7385 10.1372L25.5877 15.0732C26.0881 14.679 26.4299 14.1415 26.587 13.557Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.6776,
    cy: 25.5448,
    r: 6.43546,
    fill: "white",
    stroke: "#30D8A7",
    strokeWidth: 0.890529
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1172 25.5484C24.1172 25.1549 24.4362 24.8359 24.8296 24.8359H30.529C30.9225 24.8359 31.2414 25.1549 31.2414 25.5484C31.2414 25.9418 30.9225 26.2608 30.529 26.2608H24.8296C24.4361 26.2608 24.1172 25.9418 24.1172 25.5484Z",
    fill: "#30D8A7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6812 29.1094C27.2877 29.1094 26.9688 28.7904 26.9688 28.397V22.6976C26.9688 22.3041 27.2877 21.9851 27.6812 21.9851C28.0746 21.9851 28.3936 22.3041 28.3936 22.6976V28.397C28.3936 28.7904 28.0746 29.1094 27.6812 29.1094Z",
    fill: "#30D8A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1261153973);
export default __webpack_public_path__ + "static/media/Group 1261153973.1b68341bad1feda5998759d4628cd4f0.svg";
export { ForwardRef as ReactComponent };